<template>
  <div class="sidebar-inner">
    <!-- Top section -->
    <div class="top-section">
      <h4 class="mb-1">Tasks</h4>
      <hr>
      <!-- No tasks -->
      <div v-if="ticket.tasks.length === 0" class="no-tasks">
        <b class="text-danger">No tasks</b>
      </div>
      <!-- / No tasks -->

      <!-- Tasks grouped by ID -->
      <task-group v-for="(tasks, agentName) in tasksGroupsByAgentName"
      :agent-name="agentName" :tasks="tasks" :key="`task-for-agent-name-${agentName}`"
      ></task-group>
      <!-- / Tasks grouped by ID -->

      <!-- <task v-for="task in ticket.tasks" :key="task.id" :task="task"></task> -->
    </div>
    <!-- / Top section -->
    <!-- Bottom section -->
    <div class="bottom-section pt-3 pb-3">
      <create-task-modal :ticket-id="ticket.id" @task-added="reloadTicket"></create-task-modal>
      <a href="#" @click.prevent="openCreateTaskModal" class="btn btn-itg-dark btn-block">
        <i class="fa fa-plus-circle mr-1"></i>
        Add Task
      </a>
    </div>
    <!-- / Bottom section -->
  </div>
</template>

<script>
import Forms from "../../../../../mixins/Forms";
import Tickets from "../../../../../mixins/Tickets";
import CreateTaskModal from "./../widgets/CreateTaskModal";
// import Task from "../widgets/Task";
import { mapGetters, mapActions } from "vuex";
import TaskGroup from '../widgets/TaskGroup.vue';

export default {
  name: "TasksSidebar",
  mixins: [Forms, Tickets],
  data() {
    return {}
  },
  created() {
  },
  // components: { CreateTaskModal, Task, TaskGroup },
  components: { CreateTaskModal, TaskGroup },
  computed: {
    ...mapGetters('ticketViewer', {
      ticket: 'ticket'
    }),

    tasksWithAgentName() {
      return _.map(this.ticket.tasks, task => {
        return {
          ...task,
          agent_name: task.agent ? task.agent.name : 'Unassigned'
        }
      });
    },

    tasksGroupsByAgentName() {
      let grouped = _.groupBy(this.tasksWithAgentName, 'agent_name');

      // Move Unassigned to the beginning
      if (grouped['Unassigned']) {
        let unassigned = grouped['Unassigned'];
        delete grouped['Unassigned'];
        grouped = {
          'Unassigned': unassigned,
          ...grouped
        }
      }

      return grouped;
    }
  },
  methods: {
    ...mapActions('ticketViewer', {
      reloadTicket: 'reloadTicket'
    }),

    openCreateTaskModal() {
      this.$bvModal.show('create-task-modal');
    }
  }
}
</script>

<style scoped lang="scss">
.no-tasks {
  background: #fff;
  border-radius: 5px;
  padding: 15px;

  b {
    font-weight: 600;
  }
}
</style>
